import { render, staticRenderFns } from "./pcA.vue?vue&type=template&id=39332db6&"
import script from "./pcA.vue?vue&type=script&lang=js&"
export * from "./pcA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports